import React, { FC } from 'react'
import styles from 'styles/components/list.module.scss'
import { useDispatch } from 'react-redux'
import { push } from 'connected-react-router'
import typography from 'styles/components/typography.module.scss'
import { PushMessageType } from 'types/pushMessage'
import { format } from 'date-fns'
import { db, FirebaseTimestamp } from 'firebase/index'

type Props = {
  pushMessage: PushMessageType
}

const StaffPushMessageCard: FC<Props> = React.memo((props) => {
  const { pushMessage } = props

  const dispatch = useDispatch()
  const dateTime = format(new Date(pushMessage.created_at.seconds * 1000), 'yyyy/MM/dd HH:mm')

  const onClick = async () => {
    if (!pushMessage.is_read) {
      //既読にする
      const messageRef = db.collection('staff_push_messages').doc(pushMessage.id)
      await messageRef.update({
        is_read: true,
        updated_at: FirebaseTimestamp.now(),
      })
    }
    dispatch(push(`/` + pushMessage.page))
  }

  return (
    <li
      className={pushMessage.is_read ? styles.push_message__list__itemRead : styles.push_message__list__item}
      onClick={() => onClick()}
    >
      <h4 className={typography.headline_small}>
        {pushMessage.title}
        <br />
        {pushMessage.body}
      </h4>
      <span className={typography.description_sub}>{dateTime}</span>
    </li>
  )
})

export default StaffPushMessageCard
